import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Bookmark } from 'lucide-react';
import { useStore } from '@/shared/state/store';
import { getMovieById } from '@/shared/data';
import { MovieCard } from './components/MovieCard';

export function MyList() {
  const myListSet = useStore((s) => s.myListMovieIds);
  const movies = useMemo(
    () =>
      Array.from(myListSet)
        .map(getMovieById)
        .filter((m): m is NonNullable<typeof m> => Boolean(m)),
    [myListSet],
  );

  return (
    <div data-testid="my-list" data-count={movies.length} className="px-4">
      <h1 className="font-serif italic text-2xl text-white mb-4">My List</h1>
      {movies.length === 0 ? (
        <div className="text-center py-20">
          <Bookmark className="w-10 h-10 mx-auto text-white/30 mb-4" />
          <p className="text-white/60 text-sm">Nothing saved yet.</p>
          <Link to="/movieflix" className="inline-block mt-4 px-5 py-2 rounded-full glass text-sm">
            Browse Movieflix
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {movies.map((m) => (
            <MovieCard key={m.id} movie={m} variant="portrait" />
          ))}
        </div>
      )}
    </div>
  );
}
